module.exports = __webpack_public_path__ + "img/logo_blue1.49c8163a.png";